import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Radio, Spin } from "antd";
import dayjs from "dayjs";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  btnApi: () => void;
  selectedDate: string;
}

const MakeDayOff = (props: PropsType) => {
  const { onClose, loading, btnApi, selectedDate } = props;

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper scheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> Make a day off </h3>
            <p style={{ color: "#151718" }}>
              <b>{dayjs(selectedDate).format("dddd, MMM D")}</b> will be marked
              as a day off, and no work will be scheduled.
            </p>
            <p>
              <b>
                Any visits currently scheduled for that day will be unscheduled.
              </b>
            </p>
          </div>
        </div>

        <div className="modal_content">
          <Radio.Group
            size="small"
            style={{ display: "flex", flexDirection: "column", gap: 8 }}
            options={[
              {
                label: "Make it day off for LM 1 - Jacob E.",
                value: "only",
              },
              {
                label: "Make it day off for all crews",
                value: "all",
              },
            ]}
          />
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            Make a day off
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default MakeDayOff;
